module.exports = __webpack_public_path__ + "img/gaps.3124d2d6.svg";